import React from "react";
import "../Price/Pricelist.css";
import Price from "./Price";
import Details from "../Details/Details";
const Pricelist = () => {
  return (
    <>
      <img src="price.webp" className="imgg" alt="terrace-image" />
      <Price />
      <img src="aboutus.webp" className="imgg" alt="terrace-image" />
      <Details />
    </>
  );
};

export default Pricelist;
